import React from 'react';
import Title from './components/title/title';
import useGuidedOnboarding from './hooks/use_guided_onboarding';
import HomeContainer from './containers/home_container';
import BaseHome from './templates/base';

function Home() {
  const cards = useGuidedOnboarding();
  const isCompleted = cards.length > 0 && cards.reduce((acc, card) => acc && card.status === 'completed', true);

  return (
    <HomeContainer>
      <Title isCompleted={isCompleted} />
      <BaseHome isCompleted={isCompleted} cards={cards} />
    </HomeContainer>
  );
}

export default Home;
